/* eslint-disable class-methods-use-this */
import $ from 'jquery';
import Base from '@studiometa/js-toolkit';
import { isDev } from '../config';
import PageProductSlider from './product/PageProductSlider';
import { update as updateLazyload } from '../utils/lazyload';
import { update as updateSelectric } from '../utils/selectric';

/**
 * PageProduct class.
 */
class PageProduct extends Base {
  static config = {
    log: isDev(),
    name: 'PageProduct',
    refs: ['imageCover'],
    components: {
      PageProductSlider,
    },
  };

  /**
   * Mounted.
   *
   * @return {void}
   */
  mounted() {
    // "tricks" for not having "'prestashop' is not defined.eslintno-undef"
    const prestashop = window.prestashop || {};

    this.$el.setAttribute('data-component', this.$options.name);

    prestashop.on('updateProduct', () => {
      this.$refs.imageCover.$destroy();
    });

    prestashop.on('updatedProduct', () => {
      setTimeout(() => {
        this.$update();
        updateLazyload();
        updateSelectric();
      }, 100);
    });

    $('.accessories_group').on('change', this.onAccessoryChange);
  }

  /**
   * On accessory change.
   *
   * @param {Object} event
   */
  onAccessoryChange(event) {
    $('.accessories_group_combination').toggle(event.target.value !== '0');

    setTimeout(() => {
      updateSelectric();
    }, 100);
  }
}

const pageProduct = new PageProduct(document.body);
pageProduct.$mount();

export default pageProduct;
